module.exports = __webpack_public_path__ + "static/img/tmptype3.7477a344.png";